import React from 'react';

const MODES = [
  { id: 'stack', icon: '📱', title: 'Stack', desc: 'One at a time, swipe to decide', color: '#6366f1' },
  { id: 'scroll', icon: '📜', title: 'Scroll', desc: 'Deep dive, then decide', color: '#14b8a6' },
  { id: 'browse', icon: '🎠', title: 'Browse', desc: 'See all, tap to inspect', color: '#f59e0b' },
  { id: 'blind', icon: '🫣', title: 'Blind', desc: 'Who they are, not how they look', color: '#8b5cf6', badge: 'Different' },
  { id: 'maia', icon: '💜', title: 'Maia introduces', desc: 'One person, when she finds the right one', color: '#6366f1', badge: 'Recommended' },
];

export default function DiscoveryModeSelector({ currentMode, onSelect, compact }) {
  if (compact) {
    return (
      <div style={{ display: 'flex', gap: 6, padding: '0 16px 12px', overflowX: 'auto' }}>
        {MODES.map(m => (
          <button key={m.id} onClick={() => onSelect(m.id)} style={{
            padding: '6px 14px', borderRadius: 20, border: 'none', fontSize: 12, fontWeight: 600,
            whiteSpace: 'nowrap', cursor: 'pointer', transition: 'all 0.15s',
            background: currentMode === m.id ? m.color : 'var(--surface-alt)',
            color: currentMode === m.id ? '#fff' : 'var(--text-secondary)',
          }}>
            {m.icon} {m.title}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div style={{ padding: '16px', maxWidth: 400, margin: '0 auto' }}>
      <h3 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 4px', textAlign: 'center' }}>
        How do you want to discover?
      </h3>
      <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '0 0 16px', textAlign: 'center' }}>
        You can change this anytime
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {MODES.map(m => {
          var isActive = currentMode === m.id;
          return (
            <div key={m.id} onClick={() => onSelect(m.id)} style={{
              display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
              borderRadius: 14, cursor: 'pointer', transition: 'all 0.2s', position: 'relative',
              background: isActive ? m.color : 'var(--surface)',
              border: isActive ? 'none' : '1px solid var(--border)',
            }}>
              {m.badge && (
                <span style={{
                  position: 'absolute', top: -6, right: 10, fontSize: 10, fontWeight: 600,
                  padding: '2px 8px', borderRadius: 8,
                  background: isActive ? 'rgba(255,255,255,0.2)' : m.color + '18',
                  color: isActive ? '#fff' : m.color,
                }}>{m.badge}</span>
              )}
              <span style={{ fontSize: 22 }}>{m.icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: isActive ? '#fff' : 'var(--text-primary)' }}>{m.title}</div>
                <div style={{ fontSize: 12, color: isActive ? 'rgba(255,255,255,0.8)' : 'var(--text-secondary)' }}>{m.desc}</div>
              </div>
              {isActive && <span style={{ color: '#fff', fontSize: 16 }}>✓</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { MODES };
